import { DocumentManager } from '../../RichTextEditor';

export function emptyExperienceDocumentManager() {
  return new DocumentManager({ startDocumentComponentType: 'DocumentParagraph' });
}

const isNonEmptyDocumentComponentsObject = (documentComponents) => {
  return Boolean(
    documentComponents
    && typeof documentComponents === 'object'
    && !Array.isArray(documentComponents)
    && Object.keys(documentComponents).length > 0
  );
};

export function documentManagerFromExperience(experience) {
  const documentManager = emptyExperienceDocumentManager();

  if (isNonEmptyDocumentComponentsObject(experience?.latestVersion?.documentComponents)) {
    documentManager.addDocumentToHistoryFromData({
      document: {
        documentComponents: experience.latestVersion.documentComponents,
      },
    });
    return documentManager;
  }

  return documentManager;
}
